---
de:
  om_dashboard:
    active_alarm: Aktiver Alarm
    alarm:
      alarm: Alarme
      alarm_category: Alarmkategorie
      alarms_as_of: "{num} Aktive {critical} Alarme am {when}"
      all_active_alarms: Aktive Alarme
      command: Steuerung
      critical: kritische
      critical_active_alarms: Aktive kritische Alarme
      critical_high_alarm: Kritische hohe Alarme
      critical_low_alarm: Kritische tiefe Alarme
      duration: Dauer
      end: Ende
      energy_losses: Energieverluste [MWh]
      high_alarm: Hohe Alarme
      hydro_component_name: Turbine
      inverter_name: Quartal
      last_update: Letztes Update
      low_alarm: Tiefe Alarme
      mppt_name: MPPT
      ok: OK
      operational_status: Betriebsstatus
      recent_alarms_and_events: Aktuelle Alarme und Ereignisse
      sensor_name: Sensorname
      sensor_type: Sensortyp
      setpoint: Einstellwert
      solar_component_name: Inverter
      start: Beginn
      status: Status
      warning: Warnungen
      wind_component_name: Turbine
    alarm_status:
      environmental: Umweltbedingungen
      force_majeure: Force majeure
      grid_failure: Netzstörung
      inverter_outage: Wechselrichter-Ausfall
      manufacturer: Alarm des Herstellers
      mppt_outage: MPPT-Ausfall
      no_data: Keine Daten
      normal_operation: Normalbetrieb
      owner: Vom Besitzer gestoppt
      power_limitation: Leistungsbegrenzung
      snow_coverage: Schneebedeckung
      still_active: Aktuell
      stopped_by_owner: Vom Besitzer gestoppt
      string_anomaly: String-Anomalie
      turbine_ok: Turbine OK
    alarms: Alarme
    alarms_lowcase: Alarme
    component_status: Komponentenstatus
    drilldown:
      accumulated_hours: Kumulierte Stunden der Alarme
      accumulated_hours_of_operational_statuses: Kumulierte Stunden der Betriebsstatus
      active_power: Aktive Wirkung
      alarm_codes: Alarmcodes
      alarm_filter: Filtern nach Sensor / Stichwort
      alarm_frequency_disclaimer: Stunden mit Sonneneinstrahlung über der festgelegten Mindestgrenze (defaultmässig 60 W/m²)oh
      all_mppts: Alle MPPT
      annual_limit: Jahreslimit
      any: Alles
      availability_target: Zielwert
      charts: Diagramme
      choose_field: Feld auswählen
      choose_mppt: Wählen Sie MPPT...
      compare_another: Wechselrichter hinfügen
      compare_with: Vergleich mit
      compare_with_another: Neuer Vergleich-MPPT hinzufügen
      compare_with_inverter: Vergleich {inverter_name} mit
      compare_with_turbine: Vergleich {turbine_name} mit
      compared_power_curves: 'Leistungskurve-Vergleich:'
      contractual_availability: Vertragliche Verfügbarkeit
      critical_alarms: Kritische Alarmstatus-Einträge
      current: Strom
      current_env_flow: Aktuelles Mindestwasserflussanforderung
      date_summer: Datum Sommer
      date_winter: Datum Winter
      dc_current_unit: DC Strom [A]
      dc_current_unit_normalized: DC Strom [%]
      dc_power_unit: DC Leistung [kW]
      dc_power_unit_normalized: DC Leistung [%]
      dc_voltage_unit: DC Spannung [V]
      dc_voltage_unit_normalized: DC Spannung [%]
      downtime_hours: Ausfallzeit
      end_date: Ende
      end_time: Endzeit
      energy_based: Energiebasiert Verfügbarkeitsvertrag.
      energy_based_availability: Energiebasierte Verfügbarkeit
      energy_losses: Energieverluste
      energy_performance_index: Energy Performance Index
      energy_produced: Produzierte Energie
      expected_operating_hours: Erwartete Betriebsstunden
      export_menu:
        download_csv: CSV herunterladen
        download_jpg: JPEG herunterladen
        download_pdf: PDF herunterladen
        download_png: PNG herunterladen
        download_svg: SVG-Vektorgrafik herunterladen
        download_xls: XLS herunterlade"
        filenames:
          contractual_availability: vertragliche_verfügbarkeit
          energy_performance: performance
          energy_production: produktion
          mppt_heatmap: mppt_heatmap
          mppt_production: mppt_produktion
          power_curve: leistungskurve
          production_chart: produktion
        print_chart: Diagramm drucken
        tooltip: Daten herunterladen
        view_data_table: Datentabelle anzeigen
        view_full_screen: Vollbild anzeigen
      external_theoretical: Wettermodell
      fall_loss: Fallverlust
      fall_loss_intake: Fallverlust Einlass
      fall_loss_penstock: Fallverlust Rohrleitung
      filter: Filter
      frequency: Frequenz
      full_load_hours: Volllaststunden
      gen_l1l2: Gen L1L2
      gen_l2l3: Gen L2L3
      gen_l3l1: Gen L3L1
      group_by_category: Gruppe nach Kategorie
      hours: Stunden
      hours_without_alarms: Stunden ohne Alarme
      inverter: Wechselrichter
      inverter_production_stats: "{amount} MW für {timeframe}"
      inverter_single: 'Wechselrichter: {name}'
      key_performance: Kennzahlen
      key_performance_for: Kennzahlen für {name}
      last_outage: Letzter Ausfall war am {date}
      last_week: letzte 7 Tage
      level_downstream: Pegel Unterstrom
      level_upstream: Pegel Oberstrom
      measured: Gemessene
      most_frequent_alarms: Häufigste Alarme
      most_frequent_alarms_subtitle: Total {number} kumulierte Stunden der Alarme während {time_period}
      mppt: MPPT
      mppt_single: 'MPPT: {name}'
      no_new_outages: Keine neue Ausfälle
      no_weather_data: Keine Wetterdaten gefunden
      normalized_power: Normalisierte Leistung [%]
      normalized_values: Normalisierte Werte
      operation: In Betrieb
      operational_status: Betriebsstatus
      operational_status_of_inverter: Betriebsstatus für {name}
      operational_status_of_mppt: Betriebsstatus für {name}
      operational_status_of_mppts: MPPT-Zeitleiste
      operational_status_per_turbine: Betriebsstatus pro Turbine
      p50_target: P50
      penstock_pressure: Druck Rohrleitung
      performance: Performance
      performance_ratio: Performance Ratio
      performance_subtitle: Performance Ratio {amount}% für {timeframe}
      potential: Potenzial
      potential_loss: Potenzieller Verlust
      power: Leistung
      power_current_or_voltage: Strom, Leistung oder Spannung
      power_curve: Leistungskurve
      power_curve_for: Leistungskurve für {name}
      power_curve_inv_x_title: Theoretische Leistung
      power_curve_mppt_x_title: Referenzleistung
      power_curve_subtitle: 'Energieverluste: {losses} MWh'
      power_curve_unit_solar: kW
      power_curve_unit_wind: MW
      power_curve_x_title: Theoretische Leistung
      power_curve_y_title: Gemessene Leistung
      power_loss: Leistungsverluste
      power_y_title: Leistung [{unit}]
      production: Erzeugung
      production_for_inverter: Erzeugung für {name}
      production_in_mw: Produktion in MW
      production_per_mppt: Erzeugung pro MPPT für {name}
      production_status_per_inverter: Erzeugungsstatus pro Inverter
      reactive_power: Reaktive Wirkung
      regulation: Regelung
      remove_comparison: Vergleichmodus deaktivieren
      set_point: Sollwert
      set_point_autostart: Sollwert Autostart
      set_point_water_level: Sollwert Wasserstand
      shadow_testing_banner: Shadow-Testing ist für dieses Kraftwerk aktiv — Produktionspläne werden berechnet, aber nicht an Kaia Trade gesendet.
      show_abnormal: Nur Anomalien anzeigen
      show_all: Alles anzeigen
      show_only_time_with_active_alarms: Nur Perioden mit Alarmen anzeigen
      specific_mppts: Spezifische MPPT(s)
      start_date: Beginn
      start_time: Startzeit
      start_time_must_be_before_end_time: Startzeit muss vor Endzeit liegen
      start_up_mode: Start-up-Modus
      supervision_power: Überwachungswirkung
      temp_outside: Temperatur außen
      theoretical: Theoretische
      time_ago: Vor {duration}
      time_based: Zeitbasiert Verfügbarkeitsvertrag.
      time_based_availability: Zeitbasierte Verfügbarkeit
      time_scope:
        3m: 3 Monate
        month: Monat
        quarter: Quartal
        week: Woche
        year: Jahr
      time_with_active_alarms: Perioden mit Alarmen anzeigen
      tooltip_hidden: Legende deaktiviert aufgrund der grossen Datenmenge
      total_availability: Gesamte energiebasierte Verfügbarkeit
      triggered_at: Ausgelöst um
      turbine: Turbine
      turbine_alarm_loss: "{mw_loss} MWh verloren von {time_period}"
      turbine_power_curve_x_title: Windgeschwindigkeit
      turbine_power_curve_x_unit: m/s
      turbine_power_curve_y_title: Leistung
      turbine_power_curve_y_unit: MW
      turbine_single: 'Turbine: {name}'
      turbine_timeline: Zeitstrahl Turbinen
      types_of_alarms: Arten von Alarmen
      unavailable: Unverfügbar
      voltage: Spannung
      water_flow: Wasserfluss
      water_level: Wasserstand
      water_level_downstream: Wasserstand flussabwärts
      weather: Wetter
      weather_data: Wetterdaten
      weather_forecast: Wettervorhersage
      weather_model: Wettermodell
      wind_production_for: Produktion in MW für Turbinen
      wind_rose: Windrose
      wind_rose_missing: Windgeschwindigkeitsdaten sind nur für letztze Woche verfügbar. Nehmen Sie mit dem Portal Support Kontakt auf für weitere Informationen.
      wind_rose_text: Windgeschwindigkeit und -richtung für gewählte Zeitperiode
    duration:
      plural:
        day: "{value} Tage"
        hour: "{value} Stunden"
        minute: "{value} Minuten"
      short:
        day: "{value}T"
        hour: "{value}S"
        minute: "{value}M"
      singular:
        day: "{value} Tag"
        hour: "{value} Stunde"
        minute: "{value} Minute"
    env_flow: Umweltfluss
    filter: Liste filtern
    help:
      alarm_inactive: Alarm war in den letzten {age} aktiv, ist jetzt jedoch inaktiv
      alarm_triggered: Alarm wurde in den letzten {age} ausgelöst
      env_flow_threshold: Umweltfluss-Schwellenwertkonfiguration fehlt (Kraftwerksformular)
      no_alarm: Keine Alarme in den letzten {age}
      no_live_data: Keine Live-Daten in den letzten {age}
      sensor_type: Sensortyp "{sensor_type}" fehlt
      upper_alert_limit: Sensor upper_alert_limit nicht gesetzt
    hydro:
      reservoir_status:
        avg_inflow: Durchschnittlicher Zufluss (24h)
        avg_inflow_tooltip: Erwarteter Wasserzufluss im Durchschnitt über die nächsten 24 Stunden
        below_operational_min: Unter Betriebsminimum
        days: "{days} Tage"
        days_and_hours: "{days} Tage, {hours} Stunden"
        days_and_hours_label: "{days} Tage, {hours} Stunden"
        days_label: Tage
        hours: "{hours} Stunden"
        hours_label: Stunden
        no_data: Keine Speicherstatusdaten verfügbar
        no_inflow: Kein Zufluss
        of: von
        operational_energy: Betriebsenergie
        operational_energy_tooltip: 'Nutzbare Energie innerhalb der Betriebsgrenzen, basierend auf dem Wasserstand.<br>Betriebsbereich: {operational_capacity} MWh, zwischen {op_min_energy} MWh (Betriebsminimum) und {op_max_energy} MWh (Betriebsmaximum).<br>Gesamte Speicherenergie: {absolute_volume} MWh von {full_capacity} MWh theoretisch. Außerhalb des Betriebsbereichs: {spare_capacity} MWh.'
        production_time: Vollproduktionszeit
        production_time_tooltip: Wie lange das Kraftwerk mit dem aktuellen Speichervolumen bei voller Kapazität ({power} MW) ohne neuen Zufluss laufen kann
        reservoir_full: Speicher voll
        time_to_fill: Zeit bis zur Füllung
        time_to_fill_tooltip: Zeit zum Füllen des Speichers basierend auf dem Modellbetriebsbereich und durchschnittlichem Zufluss (24h) ohne Produktion. Erreicht möglicherweise nicht die volle theoretische Kapazität bei Betrieb in begrenztem Bereich.
        title: Aktueller Speicherstatus
    nest_comm_down: Nest-Kommunikation ausgefallen
    operations: Betrieb
    overflow: Überlauf
    overview:
      asset: Anlage
      capacity: Nennleistung
      components: Komponenten
      forecast: Prognose
      forecast_48h: Wetter in 48h
      forecast_now: Wetter jetzt
      in_48h: In 48h
      last_update: Letzte Aktualisierung
      load: Leistung
      loss: Verlust
      losses: Verluste
      lost_revenue: Verluste {currency_code}/h
      name: Name
      only_revenue: Umsatz
      production: Produktion
      production_stop: Produktion gestoppt
      revenue: Umsatz {currency_code}/h
      status: Status
      title: O&M Übersicht
    power_plant: Anlage
    power_plant_short: Anlage
    power_plant_type:
      magazine: Speicherwerk
      run_of_river: Laufwasserkraftwerk
      solar: Solarpark
      wind: Windpark
    prod_status:
      outage: Ausfall
      producing: Produziert
      ready: Bereit zum Start
    sensor_mapping:
      clear_search: Suche löschen
      discard_confirm: Sie haben nicht gespeicherte Änderungen. Verwerfen?
      filter_all: Alle
      filter_mapped: Zugeordnet
      filter_unmapped: Nicht zugeordnet
      launcher: Sensorkonfiguration
      load_error: Sensoren konnten nicht geladen werden.
      loading: Nest-Sensoren werden geladen…
      mapped_heading: Zugeordnet ({count})
      no_available_types: Keine verfügbaren Sensortypen
      no_matches: Keine Sensoren entsprechen Ihrer Suche.
      save_all: Alle speichern
      search: Nach Name suchen
      unmapped: Nicht zugeordnet
      unmapped_heading: Nicht zugeordnet ({count})
      unsaved_changes: Nicht gespeicherte Änderungen
    sensor_types:
      chart: Diagramm
      sidebar: Seitenleiste
    show_instant_triggers: Sofortauslöser anzeigen
    status:
      hydro:
        low_natural_resource: Niedrige natürliche Resource
        missing_natural_resource: Fehlende natürliche Ressource
        missing_resource: Fehlende natürliche Ressource
        missing_status: Fehlender Status
        no_change: Keine Änderung
        no_data: Keine Daten
        no_energy: Keine Leistung
        normal: Normal
        normal_operation: Normalbetrieb
        one_year_ago: vor einem Jahr
        outage: Ausfall
        recent_issue_solved: Letztes Problem gelöst
        underperforming: Tiefe Performance
      neutral:
        low_natural_resource: Niedrige natürliche Resource
        missing_natural_resource: Ausserhalb der Betriebsbedingungen
        missing_resource: Ausserhalb der Betriebsbedingungen
        missing_status: Fehlender Status
        no_change: Keine Änderung
        no_data: Keine Daten
        no_energy: Keine Leistung
        normal: Normal
        normal_operation: Normalbetrieb
        one_year_ago: vor einem Jahr
        outage: Ausfall
        recent_issue_solved: Letztes Problem gelöst
        underperforming: Tiefe Performance
      solar:
        low_natural_resource: Niedrige Einstrahlung
        missing_natural_resource: Nacht
        missing_resource: Nacht
        missing_status: Fehlender Status
        no_change: Keine Änderung
        no_data: Keine Daten
        no_energy: Keine Leistung
        normal: Normal
        normal_operation: Normalbetrieb
        one_year_ago: vor einem Jahr
        outage: Ausfall
        recent_issue_solved: Letztes Problem gelöst
        resource_above_threshold: Ressource über Schwellenwert
        resource_below_threshold: Ressource unter Schwellenwert
        underperforming: Tiefe Performance
      wind:
        low_natural_resource: Niedrige Windgeschwindigkeit
        missing_natural_resource: Ausserhalb der Betriebsbedingungen
        missing_resource: Ausserhalb der Betriebsbedingungen
        missing_status: Fehlender Status
        no_change: Keine Änderung
        no_data: Keine Daten
        no_energy: Keine Leistung
        normal: Normal
        normal_operation: Normalbetrieb
        one_year_ago: vor einem Jahr
        outage: Ausfall
        recent_issue_solved: Letztes Problem gelöst
        underperforming: Tiefe Performance
    technical: Technisch
